"use client";

import React from "react";
import { ShoppingBag, ClipboardCheck, Package, Truck } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stages = [{
  id: 1,
  title: "2020: L'Inizio del Cambiamento",
  description: "Abbiamo avviato il risanamento dei conti pubblici e lanciato i primi cantieri per la messa in sicurezza delle scuole di Albano Laziale.",
  icon: ClipboardCheck
}, {
  id: 2,
  title: "2021: Sostenibilità e Verde",
  description: "Inaugurazione di nuovi parchi urbani e potenziamento della raccolta differenziata, portando la città ai vertici regionali per l'ecologia.",
  icon: Package
}, {
  id: 3,
  title: "2022: Infrastrutture e Mobilità",
  description: "Completamento del piano asfalti e avvio della digitalizzazione dei servizi comunali per rendere la burocrazia più vicina ai cittadini.",
  icon: Truck
}, {
  id: 4,
  title: "2023-2025: Visione Futura",
  description: "Progettazione del nuovo polo culturale e consolidamento dei servizi sociali, garantendo una presenza costante sul territorio.",
  icon: ShoppingBag
}];
function TimelineStage({
  stage,
  index,
  isEven
}: {
  stage: typeof stages[0];
  index: number;
  isEven: boolean;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const Icon = stage.icon;
  return <div ref={ref} data-index={index} className="relative flex w-full flex-col items-start md:flex-row md:items-center md:justify-between">
      {}
      <div className={`absolute left-8 z-10 flex h-12 w-12 -translate-x-1/2 items-center justify-center rounded-full bg-background border-4 shadow-md transition-colors duration-700 md:left-1/2 ${isVisible ? "border-secondary" : "border-border"}`}>
        <Icon className={`h-5 w-5 transition-colors duration-700 ${isVisible ? "text-primary" : "text-muted-foreground"}`} />
      </div>

      {}
      <div className={`w-full pl-24 transition-all duration-700 md:w-[45%] md:pl-0 ${isEven ? "md:mr-auto md:pr-16 md:text-right" : "md:ml-auto md:pl-16 md:text-left"} ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        <Card className="border-border/40 shadow-sm transition-shadow duration-300 hover:shadow-md bg-card">
          <CardHeader className={`pb-2 ${isEven ? "md:items-end" : "md:items-start"}`}>
            <CardTitle className="font-default text-xl text-primary font-bold">{stage.title}</CardTitle>
          </CardHeader>
          <CardContent>
            <CardDescription className="font-default text-base text-foreground/80">
              {stage.description}
            </CardDescription>
          </CardContent>
        </Card>
      </div>
    </div>;
}
export default function FromStoreToDoor() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="246437" id="il-percorso-2020-2025" className="relative overflow-hidden bg-background py-24 text-foreground">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        {}
        <div className="mb-20 text-center">
          <h2 className="font-default mb-4 text-3xl font-bold text-primary md:text-4xl">
            Il Percorso 2020-2025
          </h2>
          <p className="font-default mx-auto max-w-2xl text-lg text-muted-foreground">
            Cinque anni di impegno concreto, trasparenza e risultati tangibili per la nostra comunità. Ecco le tappe fondamentali della nostra amministrazione.
          </p>
        </div>

        {}
        <div className="relative py-4" ref={sectionRef}>
          {}
          <div className="absolute bottom-0 left-8 top-0 w-1 -translate-x-1/2 rounded-full bg-border md:left-1/2" />

          {}
          <div className="absolute left-8 top-0 w-1 -translate-x-1/2 rounded-full bg-primary transition-all ease-out md:left-1/2" style={{
          height: sectionVisible ? "100%" : "0%",
          transitionDuration: "2500ms"
        }} />

          {}
          <div className="flex flex-col space-y-16 md:space-y-24">
            {stages.map((stage, index) => <TimelineStage key={stage.id} stage={stage} index={index} isEven={index % 2 === 0} />)}
          </div>
        </div>
      </div>
    </section>;
}